import React from 'react';
import './PlayButton.css';

interface PlayButtonProps {
  onClick: () => void;
}

const PlayButton: React.FC<PlayButtonProps> = ({ onClick }) => {
  return (
    <div className='play-button' onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="white"
        width={36}
        height={36}
        style={{ minWidth: 36, minHeight: 36 }}
      >
        <path d="M8 5v14l11-7z" />
      </svg>
    </div>
  );
};

export default PlayButton;